export default {
    dashboardSidebarLabel: "Dashboard",
    resourcesSidebarLabel: "Resources",
    practiceSidebarLabel: "Practice",
    resultSidebarLabel: "Results",
    notificationSidebarLabel: "Notifications",
    settingsSidebarLabel: "Settings",
}